import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import qs from 'query-string';

var City = function City(context) {
  var _this = this;

  _classCallCheck(this, City);

  _defineProperty(this, "closest", function (params) {
    return _this.context.http.get("/msvc/v1/cities/closest/?".concat(qs.stringify(params)));
  });

  this.context = context;
};

export default City;